import React, { useState, useEffect, useRef } from 'react';
import { motion, useAnimation, useInView } from 'framer-motion';
import styles from './Stats.module.scss';
import classNames from 'classnames/bind';

let cx = classNames.bind(styles);

const Stats = ({ stats }) => {
  // Handle different possible data structures
  const statsData = stats?.nodes || stats || [];
  
  if (!Array.isArray(statsData)) {
    console.log('Stats data is not in expected format:', statsData);
    return null;
  }

  const AnimatedValue = ({ value }) => {
    const controls = useAnimation();
    const specialChars = value.replace(/[0-9]/g, '');
    const [displayValue, setDisplayValue] = useState('0');
    const ref = useRef(null);
    const inView = useInView(ref, {
      threshold: 1,
      once: true
    });
    
    useEffect(() => {
      let isMounted = true;
      // Extract numeric value and any special characters
      const numericValue = parseInt(value.replace(/\D/g, '')) || 0;
      let animationFrame;
      
      const animateNumber = async () => {
        if (!isMounted || !inView) return;
        
        // Animate the number
        const startTime = Date.now();
        const duration = 1200; // Animation duration
        
        const updateNumber = () => {
          if (!isMounted) return;
          
          const elapsed = Date.now() - startTime;
          const progress = Math.min(elapsed / duration, 1);
          
          if (progress < 1) {
            setDisplayValue(Math.round(numericValue * progress).toString());
            animationFrame = requestAnimationFrame(updateNumber);
          } else {
            setDisplayValue(numericValue.toString());
          }
        };
        
        updateNumber();
        await new Promise(resolve => setTimeout(resolve, duration));
      };
      
      if (inView) {
        animateNumber();
      }
      
      return () => {
        isMounted = false;
        if (animationFrame) {
          cancelAnimationFrame(animationFrame);
        }
        controls.stop();
      };
    }, [value, controls, inView]);

    return (
      <div className={cx('valueWrapper')}>
        <motion.span ref={ref} className={cx('numericValue')}>
          {displayValue}
        </motion.span>
        {specialChars && (
          <span className={cx('specialChars')}>
            {specialChars}
          </span>
        )}
      </div>
    );
  };

  return (
    <section className={cx('statsSection')}>
      <div className={cx('container')}>
        <div className={cx('statsGrid')}>
          {statsData.map((stat, index) => {
            const statData = stat?.innhold || stat;
            if (!statData?.tittel || !statData?.verdi) return null;

            return (
              <div
                key={`stat-${index}`}
                className={cx('statItem')}
              >
                <div className={cx('statValue')}>
                  <AnimatedValue value={statData?.verdi} />
                </div>
                <div className={cx('statTitle')}>
                  {statData?.tittel}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Stats; 